import React, { useEffect, useState } from 'react';
import { CustomRadioButton } from '@/components/ui/CustomRadioButton';
import Link from 'next/link';

export const EventSidebar = ({
  eventTypes,
  selectedEventType: initialSelectedEventType,
  onEventTypeChange,
}) => {
  const [selectedEventType, setSelectedEventType] = useState(initialSelectedEventType);

  // Effect to notify parent component when selection changes
  useEffect(() => {
    if (onEventTypeChange) {
      onEventTypeChange(selectedEventType);
    }
  }, [selectedEventType, onEventTypeChange]);

  return (
    <div className="hidden lg:block">
      <div>
        <p className="text-xl font-semibold text-[#0C0D1A] mb-6">Categories</p>

        <div className="space-y-2">
          {eventTypes.map((eventType) => (
            <CustomRadioButton
              key={eventType}
              name="eventType"
              value={eventType}
              checked={selectedEventType === eventType}
              onChange={() => setSelectedEventType(eventType)}
              label={eventType}
              className={`
                flex items-center text-base font-medium cursor-pointer mb-2
                ${selectedEventType === eventType
              ? 'text-[#006EB7] font-bold'
              : 'text-[#0C0D1A] hover:text-[#006EB7]'}
              `}
            />
          ))}
        </div>

        {/* Border with padding */}
        <div className="border-t border-gray-200 mb-8 mt-8"></div>

        {/* CPD Certificate Section */}
        <div className="flex flex-col items-start cursor-pointer">
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center">
              <div className="w-6 h-6 rounded-full bg-[#C1E0F5] flex items-center justify-center mr-[0.75rem]">
                <img src="/img/icons/download-01.svg" alt="KFI icon" className="w-4 h-4"/>
              </div>
              <Link
                href="https://pages.pureretirement.co.uk/CPD-Certificate-Download"
                className="text-[17.25px] font-semibold text-[#000]"
              >
                CPD certificate download
              </Link>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className="ml-6" aria-hidden="true">
                <path d="M6 12L10 8L6 4" stroke="#5B5D6B" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
          <p className="text-sm text-[#373945] font-450 pt-2 w-[15rem]">All our events are structured CPD points and count towards your CPD hours.</p>
        </div>
      </div>
    </div>
  );
};
